import {
  getV1DealerIdBorrowerBorId,
  postV1ApplicationStart,
  postV1DealerIdBorrowerBorIdSkipSection,
  putV1DealerIdBorrowerBorId,
  putV1DealerIdBorrowerBorIdConsent,
  deleteV1DealerIdBorrowerBorId,
  type DtoBorrower,
  type DtoBorrowerUpdateReq,
  type DtoBorrowerConsentUpdateReq,
  type DtoCreateApplicationReq,
  type DtoCreateApplicationResp,
  type SkipSectionName,
} from "@porchpass/api-client";
import {
  assertApiSuccess,
  assertApiSuccessNoContent,
} from "../utils/assertApiSuccess";
import { EMPTY_REQUEST_BODY } from "./constants";
import { requireBorrowerId, lazyDealerId, type DomainIds } from "./types";

export function createBorrowerDomain(ids: DomainIds) {
  const getDealerId = lazyDealerId(ids);

  return {
    startApplication: async (
      body: DtoCreateApplicationReq,
    ): Promise<DtoCreateApplicationResp> => {
      const response = await postV1ApplicationStart(body);
      return assertApiSuccess<DtoCreateApplicationResp>(response);
    },

    getBorrower: async (borrowerId?: string): Promise<DtoBorrower> => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await getV1DealerIdBorrowerBorId(getDealerId(), borId);
      return assertApiSuccess<DtoBorrower>(response);
    },

    updateBorrower: async (
      body: DtoBorrowerUpdateReq,
      borrowerId?: string,
    ): Promise<DtoBorrower> => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await putV1DealerIdBorrowerBorId(
        getDealerId(),
        borId,
        body,
      );
      return assertApiSuccess<DtoBorrower>(response);
    },

    updateConsent: async (
      body: DtoBorrowerConsentUpdateReq,
      borrowerId?: string,
    ) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await putV1DealerIdBorrowerBorIdConsent(
        getDealerId(),
        borId,
        body,
      );
      return assertApiSuccess(response);
    },

    skipSection: async (sectionName: SkipSectionName, borrowerId?: string) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await postV1DealerIdBorrowerBorIdSkipSection(
        getDealerId(),
        borId,
        sectionName,
      );
      return assertApiSuccess(response);
    },

    deleteBorrower: async (borrowerId: string) => {
      const response = await deleteV1DealerIdBorrowerBorId(
        getDealerId(),
        borrowerId,
        EMPTY_REQUEST_BODY,
      );
      assertApiSuccessNoContent(response);
    },
  };
}
